import * as React from 'react'

import ModuleCard from './ModuleCard'
import IconType from '../../atoms/Icon/iconTypes'
import { colors } from '@lmc/common/constants'

type Props = {
  onClick?: () => void
}

export const EmarModuleCard = ({ onClick }: Props) => (
  <ModuleCard
    backgroundColor={colors.informationblue}
    icon={IconType.EmarHexagon}
    link="/emar-activation"
    linkText="Find out more"
    onClick={onClick}
    subtitle="Improve accountability and medication management."
    title="eMAR"
  />
)
